import { render, staticRenderFns } from "./service-agreement.vue?vue&type=template&id=4d50127e&scoped=true"
var script = {}
import style0 from "./service-agreement.vue?vue&type=style&index=0&id=4d50127e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d50127e",
  null
  
)

export default component.exports